import React, { FunctionComponent, memo } from 'react';
import { Box, Typography } from '@material-ui/core';
import Price from '../../../../../../gqlCommon/components/presentation/Price';
import optionPriceSingleCurrencyStyles from './optionPriceSingleCurrencyStyles';
import clsx from 'clsx';
import ShowIfTranslationExists from '../../../../../../common/components/ShowIfTranslationExists';
import IPrice from '../../../../../../gqlCommon/model/prices/IPrice';
import usePrice from '../../../../../../gqlCommon/hooks/prices/usePrice';
import Translation from '../../../../../../common/components/translation/Translation';
import { PriceDisplayType } from '../../../../../../../../common/enum/PriceDisplayType';

export interface IOptionPriceSingleCurrencyProps {
  prices: IPrice[];
  display: {
    optionPriceLabel?: boolean;
    hidePriceLabel?: boolean;
  };
  classes: {
    priceText: string | undefined;
  };
}

const OptionPriceSingleCurrency: FunctionComponent<IOptionPriceSingleCurrencyProps> = memo(
  ({ prices, classes, display }) => {
    const { primaryPrice } = usePrice(prices);
    const styles = optionPriceSingleCurrencyStyles();

    const renderPrice = () => (
      <Price
        className={clsx([styles.accessoryPriceContent, classes?.priceText])}
        price={primaryPrice?.money.amount}
        data-test={'option:price:primary'}
        priceDisplayType={PriceDisplayType.PRIMARY_OPTIONS}
      />
    );

    return (
      <Box className={styles.accessoryPriceContainer}>
        <Typography className={styles.accessoryPriceContent} data-test="option:price:label">
          {display?.hidePriceLabel ? (
            renderPrice()
          ) : (
            <ShowIfTranslationExists translationKey="trans__configurator__customise_page_accessories_section__accessory_price_label">
              <Translation
                id="trans__configurator__customise_page_accessories_section__accessory_price_label"
                values={{ Amount: renderPrice() }}
                data-test="option:price:translation:label"
              />
            </ShowIfTranslationExists>
          )}
        </Typography>
        <ShowIfTranslationExists translationKey="trans__configurator__customise_page_accessories_section__accessory_price_label_second">
          <Typography className={styles.accessoryPriceLabel} component="span">
            <Translation id="trans__configurator__customise_page_accessories_section__accessory_price_label_second" />
          </Typography>
        </ShowIfTranslationExists>
        <ShowIfTranslationExists translationKey="trans__configurator__customise_page_accessories_section__accessory_price_label_secondary">
          <Typography className={clsx([styles.accessoryPriceContent, styles.accessoryPriceSecondaryLabel])}>
            <Translation id="trans__configurator__customise_page_accessories_section__accessory_price_label_secondary" />
          </Typography>
        </ShowIfTranslationExists>
      </Box>
    );
  },
);

export default OptionPriceSingleCurrency;
